<template>
  <z-expansion-config-item 
    titulo="Usar Adicionar Produto Modal" 
    subtitulo="Usar o modal de adicionar produto clicando no botão de adicionar produto"
  >
    <v-switch
      v-model="store.configuracoes.USAR_ADICIONAR_PRODUTO_MODAL"
      :label="store.configuracoes.USAR_ADICIONAR_PRODUTO_MODAL ? 'Ativado' : 'Desativado'"
      left
      hide-details
      class="mt-0 pt-0 switch-reverse"
      @change="updateConfig"
    ></v-switch>
  </z-expansion-config-item>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'

const store = useConfigStore();

const { proxy } = getCurrentInstance();



async function updateConfig() {
  await store.salvarConfiguracao({
    config: 'USAR_ADICIONAR_PRODUTO_MODAL',
    valor: store.configuracoes.USAR_ADICIONAR_PRODUTO_MODAL,
    tipo: 'boolean',
    descricao: 'Usar Adicionar Produto Modal',
    ajuda: 'Usar o modal de adicionar produto clicando no botão de adicionar produto'
  });

  proxy.$store.dispatch("carregarConfiguracoes");
}

</script>

<style lang="scss" scoped>

.switch-reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;

  label {
    width: 100px;
  }
}

</style>
